import { WebViewerInstance } from '@pdftron/webviewer';
import { AllDocumentTypes } from 'types';

class Thumbnail {
  instance: WebViewerInstance;
  documentType: AllDocumentTypes;

  constructor(instance: WebViewerInstance, documentType: AllDocumentTypes) {
    this.instance = instance;
    this.documentType = documentType;
  }

  loadThumbnail(page: number, cb: (thumb: string) => void, quality = 0.5) {
    const document = this.instance.Core.documentViewer.getDocument();

    document.loadThumbnail(page, (thumbnail: HTMLCanvasElement | HTMLImageElement) => {
      let thumb: string;
      // Always draw onto a new canvas to apply white background
      // This prevents transparent backgrounds without needing to disable/enable color separations
      const canvas = window.document.createElement('canvas');
      canvas.width = thumbnail.width;
      canvas.height = thumbnail.height;
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        console.error('Could not create canvas context for thumbnail');
        thumb = '';
      } else {
        // Draw the thumbnail image first
        ctx.drawImage(thumbnail as any, 0, 0);

        // Draw a solid white background behind it to cover any transparency
        // (same technique as GraphicZone flashing annotations)
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = 'destination-over';
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        thumb = canvas.toDataURL('image/jpg', quality);
      }
      cb(thumb);
    });
  }
}

export default Thumbnail;
